const ShowDialogServiceConstants = {
  SHOW_DIALOG: "dialogService/SHOW_DIALOG",
  CLOSE_DIALOG: "dialogService/CLOSE_DIALOG"
};
export {
  ShowDialogServiceConstants as default
};
//# sourceMappingURL=DialogServiceConstants.js.map
